// Dependencies
import PropTypes from 'prop-types';

import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { orderStatusMapping } from 'utils/trade';

import formatNumber from 'utils/formatNumber';
import decimalPlaces from 'utils/decimalPlaces';
import * as TradeUtils from 'utils/trade';
import * as Transactions from 'utils/transactions';
import { getSelectedAccount, getCustomerNumber } from 'utils/customer';
import { getCustomerData } from 'utils/user';

class OrderTable extends React.Component {
  static propTypes = {
    order: PropTypes.object.isRequired,
  };

  state = {};

  componentWillMount() {
    const { order } = this.props;
    if (order.ORDER_ID) {
      this.fetchTransactions(order.ORDER_ID);
    }
  }

  componentWillReceiveProps({ order }) {
    if (order.ORDER_ID && order.ORDER_ID !== this.props.order.ORDER_ID) {
      this.fetchTransactions(order.ORDER_ID);
    }
  }

  fetchTransactions(orderId) {
    const { user } = this.props;
    const customerNumber = getCustomerNumber(user);
    const customerId = getSelectedAccount(getCustomerData(user)).get(
      'customerId',
    );

    Transactions.getTransactionsByOrder(
      customerNumber,
      customerId,
      orderId,
    ).end((err, res) => {
      if (err) {
        throw new Error('Transactions.getTransactionsByOrder failed: ' + err);
      }

      this.setState({ transactions: res.body.data });
    });
  }

  render() {
    const { order } = this.props;
    const currency = order.CURRENCY;

    return (
      <table>
        <tbody>
          <tr>
            <td className="text">
              <b>Selskap/ticker:</b>
            </td>
            <td>
              {order && `${order.TICKER_CODE} (${order.STOCK_EXCHANGE_ID})`}
            </td>
          </tr>
          <tr>
            <td className="text">
              <b>Registreringstidspunkt:</b>
            </td>
            <td>
              {order && moment(order.CREATED_DATE).format('DD.MM.YY HH:mm')}
            </td>
          </tr>
          <tr>
            <td className="text">
              <b>Sist endret:</b>
            </td>
            <td>
              {order &&
                moment(order.LAST_MODIFIED_DATE).format('DD.MM.YY HH:mm')}
            </td>
          </tr>
          <tr>
            <td className="text">
              <b>Gyldighet:</b>
            </td>
            <td>
              {order && moment(order.EXPIRATION_DATE).format('DD.MM.YY HH:mm')}
            </td>
          </tr>
          <tr>
            <td className="text">
              <b>Type:</b>
            </td>
            <td>{TradeUtils.mapType(order.TYPE)}</td>
          </tr>
          <tr>
            <td className="text">
              <b>Antall:</b>
            </td>
            <td>{formatNumber(order.TOTAL_VOLUME, 0)}</td>
          </tr>
          <tr>
            <td className="text">
              <b>Rest:</b>
            </td>
            <td>{formatNumber(order.REMAINING_VOLUME, 0)}</td>
          </tr>
          <tr>
            <td className="text">
              <b>Synlig volum:</b>
            </td>
            <td>{formatNumber(order.TOTAL_VOLUME - order.HIDDEN_VOLUME, 0)}</td>
          </tr>
          <tr>
            <td className="text">
              <b>Limit:</b>
            </td>
            <td>
              {formatNumber(order.LIMIT, 2)} {currency}
            </td>
          </tr>
          <tr>
            <td className="text">
              <b>Stop loss:</b>
            </td>
            <td>
              {formatNumber(
                order.STOP_LOSS_LIMIT,
                decimalPlaces(order.STOP_LOSS_LIMIT),
              )}{' '}
              {currency}
            </td>
          </tr>
          <tr>
            <td className="text">
              <b>Snittpris:</b>
            </td>
            <td>
              {formatNumber(order.MEAN_RATE, decimalPlaces(order.MEAN_RATE))}
            </td>
          </tr>
          <tr>
            <td className="text">
              <b>Status:</b>
            </td>
            <td>{orderStatusMapping(formatNumber(order.ORDER_STATUS, 0))}</td>
          </tr>
          <tr>
            <td className="text">
              <b>Sluttsedler:</b>
            </td>
            <td>
              {this.state.transactions &&
                this.state.transactions.map(transaction => {
                  return (
                    <Link
                      to={
                        '/holdings/details/transactions' +
                        `/${transaction.ORDER_ID}` +
                        `/${transaction.TRANSACTION_ID}`
                      }
                    >
                      {transaction.TRANSACTION_ID}
                    </Link>
                  );
                })}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  return {
    user,
  };
}

export { OrderTable };
export default connect(mapStateToProps)(OrderTable);
